const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreiconRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 1.60672,
    cy: 1.60672,
    r: 1.60672,
    fill: "#FF0000",
    style: {
      fill: "#FF0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60672,
    cy: 8.50125,
    r: 1.60672,
    fill: "#FF0000",
    style: {
      fill: "#FF0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60672,
    cy: 15.3919,
    r: 1.60672,
    fill: "#FF0000",
    style: {
      fill: "#FF0000",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreiconRed);
export default __webpack_public_path__ + "static/media/moreiconRed.df701396851786bb1d584cfef1c2ce4d.svg";
export { ForwardRef as ReactComponent };